import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 py-16 text-center">
      <p className="font-label text-6xl font-black text-background-300 md:text-8xl">404</p>
      <h1 className="mt-3 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        这个页面走丢了
      </h1>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">
        没有找到 <span className="font-label text-foreground-800">{location.pathname}</span> 对应的内容，
        可能是链接已失效，或者影视条目已经调整。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-2.5">
        <Link
          to="/"
          className="inline-flex h-10 items-center gap-1.5 rounded-md bg-primary-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-5-line w-4 h-4 flex items-center justify-center" />
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="inline-flex h-10 items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer whitespace-nowrap"
        >
          浏览电影
        </Link>
        <Link
          to="/search"
          className="inline-flex h-10 items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer whitespace-nowrap"
        >
          搜索影视
        </Link>
      </div>
    </div>
  );
}